import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from '../lang/en.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
});

const loadedLanguages = ['en'];

const setI18nLanguage = (lang) => {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
};

export const loadLanguageAsync = (lang) => {
  if (!lang) {
    return Promise.resolve();
  }

  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  return import(`../lang/${lang}.json`)
    .then((messages) => {
      i18n.setLocaleMessage(lang, messages.default);
      loadedLanguages.push(lang);
      return setI18nLanguage(lang);
    })
    .catch(() => {
      return Promise.resolve();
    });
};

export default i18n;
